import { Injectable } from '@angular/core';
import { WidgetQueryFilterService } from './widget-query-filter.service';
import * as _ from 'underscore';
import 'core-js/fn/string/includes';

@Injectable()
export class WidgetQuerySearchService {

  constructor(private widegtQueryFilter: WidgetQueryFilterService) { }

  search (widgets, criteria, sort) {
    const resources = widgets;
    const query = criteria;
    let matches = resources;
    let filterItems = {};

    if (query) {
      Object.keys(query).map(function (attribute) {
        const queryItem = query[attribute];
        const comparisonOperator = queryItem.ComparisonOperator;
        const attributeValueList = queryItem.AttributeValueList;
        let filterItem = '{}';
        let value;
        // Need just the values from the attributes for the memory store
        switch (Object.keys(attributeValueList[0])[0]) {
          case 'BOOL':
            value = attributeValueList[0].BOOL;
            filterItem = `{"${attribute}": ${value}}`;
            break;
          case 'N':   // number
            value = attributeValueList[0].N;
            filterItem = `{"${attribute}": {"${comparisonOperator}":${value}}}`;
            break;
          case 'S':   // string
            value = attributeValueList[0].S;
            filterItem = `{"${attribute}": {"${comparisonOperator}":"${value}"}}`;
            break;
          default:
        }
        filterItem = JSON.parse(filterItem);
        // this 'AND's all the filter items
        // TODO: if OR is required they need to be add to an array that is passed to queryFilter
        filterItems = Object.assign(filterItems, filterItem);
      });
      /* eslint-enable */
      matches = this.widegtQueryFilter.queryFilter(resources, filterItems);
    }

    if (sort) {
      matches.sort(function (a, b) {
        return a[sort] - b[sort];
      });
    }

    return matches;
  };

  filterByPostcode(postcode, widgets) {
    return _.filter(widgets, (widget) => {
      return (widget['requires_postcodes'] === undefined || widget['requires_postcodes'] === null ||
        widget['requires_postcodes'].length === 0 || _.contains(widget['requires_postcodes'], Number(postcode)));
    });
  }

}



// WEBPACK FOOTER //
// ./app/widgets/widgetDisplayQueries/widget-query-search.service.ts